import {CrudService} from '@ngx-ivengi/crud';
import {Charge} from './charge.model';
import {Injectable} from '@angular/core';

@Injectable()
export class ChargeService extends CrudService<Charge> {
  public entityType = Charge;
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/charge/charge.service.ts